import { fmtDate } from "@/lib/api";
import { ENQ_STATUSES } from "@/lib/constants";
import { Empty } from "@/components/admin/common";
import { LeadActions } from "./LeadActions";
import { FollowBadge, LeadMeta, StatusSelect } from "./LeadBits";

const LeadCard = ({ lead, onOpen, onStatus, onBook, onDelete }) => (
  <article className="rounded-xl border border-slate-200 bg-white p-3.5 shadow-sm hover:border-sky-300 transition-colors" data-testid={`lead-card-${lead.id}`}>
    <button type="button" onClick={() => onOpen(lead)} className="text-left w-full" data-testid={`lead-open-${lead.id}`}>
      <p className="font-semibold text-navy leading-tight">{lead.name}</p>
      <p className="text-xs text-slate-500 mt-0.5">{lead.phone} · Travel {fmtDate(lead.travel_date)}</p>
      {lead.package_name && <p className="mt-1.5 text-xs text-slate-600 line-clamp-1">{lead.package_name}</p>}
    </button>
    <div className="mt-2"><LeadMeta lead={lead} /></div>
    <div className="mt-2"><FollowBadge lead={lead} /></div>
    <div className="mt-3 pt-3 border-t border-slate-100 flex items-center justify-between gap-2">
      <StatusSelect lead={lead} onChange={onStatus} className="h-8 w-[136px] text-xs" />
      <LeadActions lead={lead} onBook={onBook} onDelete={onDelete} />
    </div>
  </article>
);

export const LeadBoard = ({ leads, ...handlers }) => (
  <div className="flex gap-4 overflow-x-auto pb-4 snap-x" data-testid="leads-board">
    {ENQ_STATUSES.map((s) => {
      const col = leads.filter((l) => l.status === s.value);
      return (
        <section key={s.value} className="snap-start shrink-0 w-[300px] rounded-2xl bg-slate-100/70 p-3" data-testid={`leads-column-${s.value}`}>
          <header className="flex items-center justify-between px-1 pb-3">
            <p className="flex items-center gap-2 text-sm font-semibold text-navy"><span className={`h-2.5 w-2.5 rounded-full ${s.bar}`} />{s.label}</p>
            <span className="font-mono text-xs text-slate-500" data-testid={`leads-column-count-${s.value}`}>{col.length}</span>
          </header>
          <div className="space-y-3 max-h-[68vh] overflow-y-auto pr-0.5">
            {col.length === 0 ? <Empty>No leads</Empty> : col.map((l) => <LeadCard key={l.id} lead={l} {...handlers} />)}
          </div>
        </section>
      );
    })}
  </div>
);
